import classNames from 'classnames';
import React from 'react';
function getRandomKey() {
    return Math.random().toString(36)
        .slice(-6);
}
export const CodeDiffCard = ({ diff, type }) => {
    const isNewCode = type === 'new';
    return (React.createElement("div", { className: 'code' }, diff.map((part) => {
        const { added, removed, value } = part;
        const className = classNames('diff-text', {
            addedFromOld: !isNewCode && added,
            addedToNew: isNewCode && added,
            removedFromNew: isNewCode && removed,
            removedFromOld: !isNewCode && removed
        });
        return (React.createElement("span", { className: className, key: getRandomKey() }, value));
    })));
};
